import viewMixin from '@/components/core/consumers/viewMixin';
import ApiService from '@/services/apiService';
import { userItemsPerListMixin } from '@/utils/vuex';
import { createComparisonOperatorOptions } from '@/utils/comparisonOperators';
import cloneDeep from 'lodash/cloneDeep';
import { mapState, mapGetters } from 'vuex';
const emptyModel = {
  filter: {
    type: 'wizard',
    contentTypes: {}
  },
  properties: {}
};
const defaultItemsPerPage = 10;
const defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
const EDITOR_DEFAULTS = {
  jsonata: '$.value = 1',
  javascript: 'return x.value == 1'
};
export default {
  name: 'ViewConnectorsConsumersFilters',
  mixins: [viewMixin, userItemsPerListMixin],
  data() {
    return {
      searchItem: '',
      deleteItemId: null,
      deletePrompt: false,
      accounts: [],
      filterTypes: ['jsonata', 'javascript'],
      filterModel: cloneDeep(emptyModel),
      filterExtended: false,
      filterRows: [],
      selectedAccount: null,
      selectedAccounts: [],
      loadingAccounts: true,
      isCreateDialog: true,
      cascadePrompt: false,
      cascadeFlows: [],
      cascadeItemId: null,
      tableOptions: defaultTableOptions
    };
  },
  computed: {
    ...mapState('authentication', ['tenantId']),
    ...mapGetters({
      isFeatureFlagEnabled: 'app/isFeatureFlagEnabled',
      sessionUserId: 'authentication/userId'
    }),
    inputTypes() {
      switch (this.filterModel.filter.type) {
        default:
          return ['application/json', 'text/plain', 'generic'];
      }
    },
    attributesSelect() {
      return [
      // {
      //   text: this.$i18n_t('Consumers.Filter.createDialog.attributes.accountId'),
      //   value: 'account_id',
      // },
      {
        text: this.$i18n_t('Consumers.Filter.createDialog.attributes.configId'),
        value: 'config_id'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.attributes.stateId'),
        value: 'state_id'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.attributes.dtwinId'),
        value: 'dtwin_id'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.attributes.dtwinTitle'),
        value: 'dtwin_title'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.attributes.unit'),
        value: 'unit'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.attributes.stateIdentifier'),
        value: 'state_identifier'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.attributes.stateTtype'),
        value: 'state_type'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.attributes.sourceType'),
        value: 'source_type'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.attributes.parserVariable'),
        value: 'parser_variable'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.attributes.sourceIdentifier'),
        value: 'source_identifier'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.attributes.timestamp'),
        value: 'timestamp'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.attributes.twin_category'),
        value: 'twin_category'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.attributes.geolocation'),
        value: 'geolocation'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.attributes.vdevice_groups'),
        value: 'vdevice_groups'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.attributes.twin_tags'),
        value: 'twin_tags'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.attributes.twin_key_value'),
        value: 'twin_key_value'
      }, ...(this.isFeatureFlagEnabled('env_dispatcher_devicetype_fallback') === false ? [{
        text: this.$i18n_t('Consumers.Filter.createDialog.attributes.device_driver_id'),
        value: 'device_driver_id'
      }] : [])];
    },
    operatorSelect() {
      const translate = (...args) => this.$i18n_t(...args);
      return createComparisonOperatorOptions(translate).map(option => ({
        ...option,
        text: option.label
      }));
    },
    tableLocalizations() {
      return {
        headers: [{
          text: this.$i18n_t('Connectors.Filter.table.id'),
          value: 'id',
          align: 'center'
        }, {
          text: this.$i18n_t('Connectors.Filter.table.name'),
          value: 'name',
          align: 'start'
        }, {
          text: this.$i18n_t('Connectors.Filter.table.type'),
          sortable: true,
          value: 'filter.type',
          align: 'start'
        }, {
          text: this.$i18n_t('Connectors.Filter.table.inputType'),
          sortable: true,
          value: 'filter.inputType'
        }, {
          text: this.$i18n_t('NiotaClassic.Common.table.account'),
          value: 'tenantId'
        }, {
          text: this.$i18n_t('Connectors.Filter.table.createdAt'),
          value: 'createdAt'
        }, {
          value: 'actions'
        }],
        footerProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [10, 20, 50]
        }
      };
    }
  },
  watch: {
    selectedAccounts() {
      this.fetchFilters(this.selectedAccounts);
    },
    inputTypes() {
      if (this.inputTypes.length === 1) {
        this.filterModel.filter.inputType = this.inputTypes[0];
      }
    },
    'filterModel.filter.type'() {
      if (!this.filterModel.id || typeof this.filterModel.filter.definition !== 'string') {
        // Only set defaults if it's a new filter or the definition is not a string.
        this.setEditorDefaults();
      }
    }
  },
  created() {
    this.fetchAccounts();
  },
  mounted() {
    this.setupFilterRows();
  },
  methods: {
    switchExtended() {
      if (this.filterExtended && this.filterModel.filter.type === 'wizard') {
        this.filterModel.filter.type = 'jsonata';
      }
    },
    setEditorDefaults() {
      if (!EDITOR_DEFAULTS[this.filterModel.filter.type]) {
        this.filterModel.filter.definition = EDITOR_DEFAULTS.jsonata;
        console.warn(`Unexpected filter type: ${this.filterModel.filter.type}`);
      } else {
        this.filterModel.filter.definition = EDITOR_DEFAULTS[this.filterModel.filter.type];
      }
    },
    setupFilterRows() {
      this.filterRows = [...this.filterRows, {}];
    },
    sanitizeFilterRows() {
      // remove any entries that are missing at least one field
      this.filterRows = this.filterRows.filter(row => {
        return row.attribute && row.operator && row.values;
      });
      this.filterRows.push({});
    },
    removeFilterRow(index) {
      this.filterRows.splice(index, 1);
    },
    addFilterRow(index) {
      this.filterRows.splice(index + 1, 0, {});
    },
    openEditModal(item = null) {
      if (item === null) {
        this.isCreateDialog = true;
        this.filterModel = cloneDeep(emptyModel);
        this.selectedAccount = null;
        this.filterExtended = false;
        this.filterRows = [{}];
      } else {
        this.isCreateDialog = false;
        this.filterModel = cloneDeep(item || emptyModel);
        this.selectedAccount = this.accounts.find(acc => acc.id === item.tenantId);
        this.filterExtended = this.filterModel.filter.type !== 'wizard';
        this.filterRows = (!this.filterExtended ? this.filterModel.filter.definition : null) || [{}];
      }
      this.formDialogOpen = true;
    },
    save() {
      let promise = null;
      let model = cloneDeep(this.filterModel);
      if (!this.filterExtended) {
        // Wizard view was active when saving so we save only the wizard data
        model.filter = {
          type: 'wizard',
          contentTypes: {},
          definition: this.filterRows,
          inputType: 'generic'
        };
      }
      if (this.filterModel.id) {
        promise = ApiService.consumerFiltersUpdate(this.filterModel.id, model);
      } else {
        promise = ApiService.consumerFiltersCreate(this.selectedAccount, model);
      }
      promise.then(() => {
        if (this.filterModel.id) {
          this.$snack(`${this.$i18n_t('Connectors.Filter.editDialog.filterUpdated')}`, 'success');
        } else {
          this.$snack(`${this.$i18n_t('Connectors.Filter.editDialog.filterCreated')}`, 'success');
        }
        this.fetchFilters();
        this.closeDialog();
      }).catch(e => {
        this.$snack(e.response.data.message, 'error');
      });
    },
    async showDeletePrompt(id) {
      this.deleteItemId = id;
      try {
        const usage = await ApiService.consumerFiltersGetUsage(id);
        if (usage && Array.isArray(usage.flows) && usage.flows.length) {
          this.cascadeFlows = usage.flows;
          this.cascadeItemId = id;
          this.cascadePrompt = true;
          return;
        }
      } catch (e) {
        // fallback to generic prompt if usage endpoint fails
      }
      this.deletePrompt = true;
    },
    async deleteFilter(id) {
      try {
        await ApiService.consumerFiltersDelete(id);
        this.fetchFilters(this.selectedAccounts);
      } catch (e) {
        var _e$response;
        const msg = (e === null || e === void 0 || (_e$response = e.response) === null || _e$response === void 0 || (_e$response = _e$response.data) === null || _e$response === void 0 ? void 0 : _e$response.message) || (e === null || e === void 0 ? void 0 : e.message) || '';
        let payload = null;
        try {
          payload = JSON.parse(msg);
        } catch {
          // ignore
        }
        if (payload && payload.componentType === 'filter' && Array.isArray(payload.flows) && payload.flows.length) {
          this.deletePrompt = false;
          this.cascadeFlows = payload.flows;
          this.cascadeItemId = id;
          this.cascadePrompt = true;
        } else {
          var _e$response2;
          this.$snack(((_e$response2 = e.response) === null || _e$response2 === void 0 || (_e$response2 = _e$response2.data) === null || _e$response2 === void 0 ? void 0 : _e$response2.message) || this.$i18n_t('Common.error'), 'error');
        }
      } finally {
        this.deletePrompt = false;
      }
    },
    async confirmCascadeDelete() {
      try {
        await ApiService.consumerFiltersDelete(this.cascadeItemId, true);
        this.fetchFilters(this.selectedAccounts);
      } finally {
        this.cascadePrompt = false;
        this.cascadeItemId = null;
        this.cascadeFlows = [];
      }
    },
    fetchAccounts() {
      this.$store.dispatch('app/loadAccounts').then(accounts => {
        this.accounts = accounts;
      }).catch(error => {
        console.error(error);
        this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.errorFindingAccounts'), 'error');
      });
    }
  }
};